import React from 'react';

const StorePageHero = ({
  eyebrow,
  title,
  subtitle,
  centered = false,
  children,
  footer,
}) => (
  <section className="store-hero">
    <div className="store-hero-blobs" aria-hidden="true">
      <div className="store-hero-blob store-hero-blob-primary" />
      <div className="store-hero-blob store-hero-blob-accent" />
    </div>
    <div className={`store-container relative py-6 sm:py-8 ${centered ? 'text-center' : ''}`}>
      {centered ? (
        <div className="max-w-3xl mx-auto">{children}</div>
      ) : (
        <>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div className="min-w-0">
              {eyebrow && <p className="store-eyebrow">{eyebrow}</p>}
              <h1 className="store-title">{title}</h1>
              {subtitle && <p className="store-subtitle">{subtitle}</p>}
            </div>
            {children && (
              <div className="flex flex-wrap items-center gap-3 shrink-0">{children}</div>
            )}
          </div>
          {footer}
        </>
      )}
    </div>
  </section>
);

export default StorePageHero;
